import { SearchIcon } from './search-icon'
import { SearchInput } from './search-input'
import { SearchRoot } from './search-root'

export const Search = {
  icon: SearchIcon,
  input: SearchInput,
  root: SearchRoot,
}
